import { action, makeObservable } from 'mobx';
import { createContext, useContext } from 'react';
import { bpHistory } from 'global/bpHistory';
import IGroupCensusReviewPageStore, {
  GroupCensusReviewDomainParams,
} from 'store/modules/census/group-based/iGroupCensusReviewPageStore';

/* TESTING_POLICY: CYPRESS_ONLY */

export interface CensusInitiateAddEeDomainParams extends GroupCensusReviewDomainParams {
  cartId: string;
}

export default class CensusStatisticsInitiateAddEePageStore extends IGroupCensusReviewPageStore {
  protected _domainData;

  public onBackRedirect(): void {
    bpHistory.push(
      `/census-initiate-add-employees-upload/${this._domainData.groupId}?periodId=${this._domainData.enrollmentPeriodId}&cartId=${this._domainData.cartId}`,
    );
  }

  public onCompleteRedirect(): void {
    bpHistory.push(
      `/initiate-add-employees/${this._domainData.enrollmentPeriodId}?groupId=${this._domainData.groupId}&cartId=${this._domainData.cartId}`,
    );
  }

  constructor(domainData: CensusInitiateAddEeDomainParams) {
    super();

    this._domainData = domainData;

    makeObservable<CensusStatisticsInitiateAddEePageStore>(this, {
      onBackRedirect: action.bound,
      onCompleteRedirect: action.bound,
    });
  }
}

const CensusStatisticsInitiateAddEePageStoreContext = createContext(
  new CensusStatisticsInitiateAddEePageStore({
    enrollmentPeriodId: 'stub-enrollment-id',
    groupId: 'stub-group-id',
    cartId: 'stub-cart-id',
  }),
);

export const useCensusStatisticsInitiateAddEePageStore = (): CensusStatisticsInitiateAddEePageStore => {
  return useContext(CensusStatisticsInitiateAddEePageStoreContext);
};

export { CensusStatisticsInitiateAddEePageStoreContext };
